/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Credit_Packs_Non_RefundableInputs */

const en_agb_credit_packs_non_refundable = /** @type {(inputs: Agb_Credit_Packs_Non_RefundableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit packs are digital content within the meaning of BGB S356(5). After confirmation of the waiver of withdrawal rights and immediate provision of credits, refunds are excluded.`)
};

const de_agb_credit_packs_non_refundable = /** @type {(inputs: Agb_Credit_Packs_Non_RefundableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit-Pakete sind digitale Inhalte im Sinne des BGB S356 Abs. 5. Nach Bestaetigung des Widerrufsrechtsverzichts und sofortiger Bereitstellung der Credits ist eine Rueckerstattung ausgeschlossen.`)
};

const fr_agb_credit_packs_non_refundable = /** @type {(inputs: Agb_Credit_Packs_Non_RefundableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les packs de credits sont du contenu numerique au sens du BGB S356(5). Apres confirmation de la renonciation au droit de retractation, ils ne sont pas remboursables.`)
};

const es_agb_credit_packs_non_refundable = /** @type {(inputs: Agb_Credit_Packs_Non_RefundableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los paquetes de creditos son contenido digital segun BGB S356(5). Tras confirmar la renuncia al derecho de desistimiento, no son reembolsables.`)
};

const it_agb_credit_packs_non_refundable = /** @type {(inputs: Agb_Credit_Packs_Non_RefundableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I pacchetti di crediti sono contenuto digitale ai sensi del BGB S356(5). Dopo la conferma della rinuncia al diritto di recesso, non sono rimborsabili.`)
};

const nl_agb_credit_packs_non_refundable = /** @type {(inputs: Agb_Credit_Packs_Non_RefundableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creditpakketten zijn digitale inhoud in de zin van BGB S356(5). Na bevestiging van de afstand van het herroepingsrecht zijn ze niet-restitueerbaar.`)
};

const pl_agb_credit_packs_non_refundable = /** @type {(inputs: Agb_Credit_Packs_Non_RefundableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paczki kredytow sa trescia cyfrowa w rozumieniu BGB S356(5). Po potwierdzeniu rezygnacji z prawa odstapienia nie podlegaja zwrotowi.`)
};

const fi_agb_credit_packs_non_refundable = /** @type {(inputs: Agb_Credit_Packs_Non_RefundableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krediittipaketit ovat digitaalista sisältöä BGB S356(5):n mukaisesti. Peruutusoikeuden luopumisen jälkeen ne ovat ei-palautettavia.`)
};

const da_agb_credit_packs_non_refundable = /** @type {(inputs: Agb_Credit_Packs_Non_RefundableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditpakker er digitalt indhold i henhold til BGB S356(5). Efter bekraeftelse af afkald pa fortrydelsesretten er de ikke-refunderbare.`)
};

const sv_agb_credit_packs_non_refundable = /** @type {(inputs: Agb_Credit_Packs_Non_RefundableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditpaket ar digitalt innehall enligt BGB S356(5). Efter bekraftelse av avsagelse av angerratten ar de ej aterbetalbara.`)
};

/**
* | output |
* | --- |
* | "Credit packs are digital content within the meaning of BGB S356(5). After confirmation of the waiver of withdrawal rights and immediate provision of credits,..." |
*
* @param {Agb_Credit_Packs_Non_RefundableInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_credit_packs_non_refundable = /** @type {((inputs?: Agb_Credit_Packs_Non_RefundableInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Credit_Packs_Non_RefundableInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_credit_packs_non_refundable(inputs)
	if (locale === "fr") return fr_agb_credit_packs_non_refundable(inputs)
	if (locale === "es") return es_agb_credit_packs_non_refundable(inputs)
	if (locale === "it") return it_agb_credit_packs_non_refundable(inputs)
	if (locale === "nl") return nl_agb_credit_packs_non_refundable(inputs)
	if (locale === "pl") return pl_agb_credit_packs_non_refundable(inputs)
	if (locale === "fi") return fi_agb_credit_packs_non_refundable(inputs)
	if (locale === "da") return da_agb_credit_packs_non_refundable(inputs)
	if (locale === "sv") return sv_agb_credit_packs_non_refundable(inputs)
	return en_agb_credit_packs_non_refundable(inputs)
});